export const SIDEBAR_EVENTS = {
  deals: 'ofertas_sidebar',
  schedule: 'agenda_sidebar',
  liquidations: 'facturacion_sidebar',
  reservationConfiguration: 'confreservas_sidebar',
  experiences: 'experiencias_sidebar',
  reviews: 'reseñas_sidebar',
  charts: 'metricas_sidebar',
  benefits: 'beneficios_sidebar',
  usersManagement: 'gestionarusuarios_sidebar',
  helpCenter: 'centrodeayuda_sidebar',
} as const;

export const HEADER_EVENTS = {
  createBooking: 'hacer_reserva',
  createExperience: 'sumar_experiencia',
  profile: 'mi_perfil',
  notifications: 'mis_notificaciones',
} as const;

export const HOME_EVENTS = {
  announcement: 'clicks_novedades',
  goToSchedule: 'ir_a_agenda',
  averageRating: 'calificacion_promedio',
} as const;

export const REVIEWS_EVENTS = {
  answer: 'responde_reseñas',
  answerSent: 'reseñas_enviadas',
} as const;

type ValueOf<T> = T[keyof T];

export type AnalyticsEvent =
  | ValueOf<typeof SIDEBAR_EVENTS>
  | ValueOf<typeof HEADER_EVENTS>
  | ValueOf<typeof HOME_EVENTS>
  | ValueOf<typeof REVIEWS_EVENTS>;

export type AnalyticsParams = Record<string, string | number | null>;
